import { useRef } from 'react';
import { useOutsideClick } from '../hooks/useOutsideClick';
import {
  OKShareButton,
  TelegramShareButton,
  TwitterShareButton,
  VKShareButton,
} from 'react-share';
import copy from 'copy-to-clipboard';

const Share = ({ shareUrl, hide }) => {
  const ref = useRef(null);
  useOutsideClick(ref, hide);

  const copyAddr = (evt) => {
    copy(window.location.href);
    evt.preventDefault();
    evt.stopPropagation();
    return false;
  };

  return (
    <ul ref={ref}>
      <li>
        <a href="#" onClick={copyAddr}>
          <img src="/static/img/icons/layers.svg" alt="icon" />
          <span>Скопировать ссылку </span>
        </a>
      </li>
      <li>
        <VKShareButton url={shareUrl}>
          <img src="/static/img/icons/wk.svg" alt="icon" />
          <span>Вконтакте</span>
        </VKShareButton>
      </li>
      <li>
        <OKShareButton url={shareUrl}>
          <img src="/static/img/icons/ok.svg" alt="icon" />
          <span>Одноклассники</span>
        </OKShareButton>
      </li>
      <li>
        <TelegramShareButton url={shareUrl}>
          <img src="/static/img/icons/icon-telegram.svg" alt="icon" />
          <span>Telegram</span>
        </TelegramShareButton>
      </li>
      <li>
        <TwitterShareButton url={shareUrl}>
          <img src="/static/img/icons/twiter.svg" alt="icon" />
          <span>Twitter</span>
        </TwitterShareButton>
      </li>
    </ul>
  );
};

export default Share;
